import { join } from 'light-component';
import { InputNumber } from 'antd';
import { Box } from '../../../box';
import { Highlighter } from '../../component';
import { service } from '../service';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { NumberProps } from './types';

export function NumberInputMode(props: NumberProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <InputNumber
          style={{ width: '100%' }}
          value={props.value}
          type='number'
          readOnly={props.readonly === true}
          placeholder={props.textPlaceholder}
          onChange={value => props.onPropsChange?.({ value })}
        />
      </Box>
    </Box>
  );
}
